import { snakeCase, camelCase } from 'lodash';

import { gql } from '@zenbusiness/application-commons-graphql';

export const PROMPT_QUERY = gql(`
  query FindPrompt($input: FindPromptInput!) {
    findPrompt(input: $input) {
      uuid
      systemContent
      userContent
      name
      description
      version
      status
      structuredOutput {
        name
        schema {
          reasons
          conclusion
          introduction
        }
      }
      maxCompletionTokens
      temperature
      model
    }
  }
`);

export const COMPLETIONS_MUTATION = gql`
  mutation Completions(
    $model: String!,
    $temperature: Float!,
    $maxCompletionTokens: Int!,
    $metadata: PromptMetadata!
    $messages: [CompletionMessageInput!]!
    $responseFormat: CompletionResponseFormatInput!
  ) {
    completions(
      model: $model,
      temperature: $temperature,
      maxCompletionTokens: $maxCompletionTokens,
      metadata: $metadata,
      messages: $messages,
      responseFormat: $responseFormat
    ) {
      id
      model
      messages {
        role
        content
        parsed {
          conclusion
          introduction
          reasons {
            title
            description
          }
        }
      }
    }
  }
`;

/**
 * Fill content with values.
 * @param {object} values - Object with key:value pairs where value is a string.
 * @param {string} data - The data with placeholders to fill with `{{}}` format.
 * @returns {string} - The filled content string.
 */
export const fillContent = (values, data = '') => {
  let filledString = data;
  const keysToFill = Object.keys(values);

  keysToFill.forEach((key) => {
    const snakeKey = snakeCase(key);
    const camelKey = camelCase(key);
    filledString = filledString.replace(`{{${snakeKey}}}`, `${snakeKey}: ${values[key]}`);
    filledString = filledString.replace(`{{${camelKey}}}`, `${camelKey}: ${values[key]}`);
  });

  return filledString;
};
